
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "t": "1588860547756",
    "class": "icon",
    "viewBox": "0 0 1024 1024",
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "p-id": "2727",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "width": "200",
    "height": "200"
  },
  "children": [
    {
      "tag": "defs"
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M64 160v704h896V160z m64 64h768v444.992l-168.992-169.984-23.008-23.008-144.992 144.992-184-185.984-23.008-23.008-224 224z m640 64a63.968 63.968 0 1 0 0 128 63.968 63.968 0 1 0 0-128z m-416 215.008L646.016 800H128v-72.992z m352 64l192 192V800h-159.008l-132.992-134.016z",
        "p-id": "2728"
      }
    }
  ]
})
    }
  